import PopupMenu from "@/components/atoms/PopupMenu";
import Checkbox from "@/components/atoms/Checkbox";
import { Settings } from "lucide-react";

interface SelectOption {
  id: string;
  label: string;
}

interface TableSettingsProps {
  selectOptions: SelectOption[];
  selectedColumns: string[];
  setSelectedColumns: (columns: string[]) => void;
}

const TableSettings = ({ selectOptions, selectedColumns, setSelectedColumns }: TableSettingsProps) => {
  const handleCheckboxChange = (id: string) => {
    if (selectedColumns.includes(id)) {
      setSelectedColumns(selectedColumns.filter((col) => col !== id));
    } else if (selectedColumns.length < 7) {
      setSelectedColumns([...selectedColumns, id]);
    }
  };

  return (
    <PopupMenu
      trigger={
        <button className="inline-flex items-center text-sm gap-2 px-4 py-2 bg-background border border-border rounded-md hover:bg-accent font-medium">
          <Settings size={16} />
          <span>Table Settings</span>
        </button>
      }
      content={
        <div className="p-4">
          <h4 className="mb-2 text-sm font-medium">Table Settings</h4>
          {selectOptions.map((option) => (
            <div key={option.id} className="flex items-center mb-2">
              <Checkbox
                id={option.id}
                checked={selectedColumns.includes(option.id)}
                onCheckedChange={() => handleCheckboxChange(option.id)}
                disabled={selectedColumns.length >= 7 && !selectedColumns.includes(option.id)}
              />
              <label
                htmlFor={option.id}
                className={`ml-2 text-sm ${
                  selectedColumns.length >= 7 && !selectedColumns.includes(option.id)
                    ? "dark:text-gray-400"
                    : "dark:text-white-300"
                }`}
              >
                {option.label}
              </label>
            </div>
          ))}
        </div>
      }
    />
  );
};

export default TableSettings;
